export default __webpack_public_path__ + "images/b38cba435a1b27c77acc68dd9b2539ac-spd_header_image_desktop.webp";